export default "__VITE_ASSET__CWu5xioT__"